import { render, staticRenderFns } from "./RestMaterials.vue?vue&type=template&id=bdd58b96&scoped=true"
import script from "./RestMaterials.vue?vue&type=script&lang=js"
export * from "./RestMaterials.vue?vue&type=script&lang=js"
import style0 from "./RestMaterials.vue?vue&type=style&index=0&id=bdd58b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd58b96",
  null
  
)

export default component.exports